import React from "react";

function BulkOrder() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="25"
      height="25"
      enableBackground="new 0 0 512 512"
      viewBox="0 0 1700 1700"
    >
      <path
        fill="#d3aa84"
        d="M1578 1535.3h-432c-22.1 0-40-17.9-40-40v-367.1c0-22.1 17.9-40 40-40h432c22.1 0 40 17.9 40 40v367.1c0 22.1-17.9 40-40 40z"
        data-original="#d3aa84"
      ></path>
      <path
        fill="#efc8a0"
        d="M1408.7 1221.6h-93.4c-11.1 0-20-8.9-20-20v-113.4h133.4v113.4c0 11-8.9 20-20 20z"
        data-original="#efc8a0"
      ></path>
      <path
        fill="#efc8a0"
        d="M1322 1088.2H890c-22.1 0-40-17.9-40-40V681.1c0-22.1 17.9-40 40-40h432c22.1 0 40 17.9 40 40v367.1c0 22.1-17.9 40-40 40z"
        data-original="#efc8a0"
      ></path>
      <path
        fill="#d3aa84"
        d="M1152.7 774.5h-93.4c-11.1 0-20-9-20-20V641.1h133.4v113.4c0 11-8.9 20-20 20zM810 1088.2H378c-22.1 0-40-17.9-40-40V681.1c0-22.1 17.9-40 40-40h432c22.1 0 40 17.9 40 40v367.1c0 22.1-17.9 40-40 40z"
        data-original="#d3aa84"
      ></path>
      <path
        fill="#efc8a0"
        d="M640.7 774.5h-93.4c-11 0-20-9-20-20V641.1h133.4v113.4c0 11-8.9 20-20 20zm425.3 760.8H634c-22.1 0-40-17.9-40-40v-367.1c0-22.1 17.9-40 40-40h432c22.1 0 40 17.9 40 40v367.1c0 22.1-17.9 40-40 40z"
        data-original="#efc8a0"
      ></path>
      <path
        fill="#d3aa84"
        d="M896.7 1221.6h-93.4c-11 0-20-8.9-20-20v-113.4h133.4v113.4c0 11-8.9 20-20 20zM554 1535.3H122c-22.1 0-40-17.9-40-40v-367.1c0-22.1 17.9-40 40-40h432c22.1 0 40 17.9 40 40v367.1c0 22.1-17.9 40-40 40z"
        data-original="#d3aa84"
      ></path>
      <path
        fill="#efc8a0"
        d="M384.7 1221.6h-93.4c-11 0-20-8.9-20-20v-113.4h133.4v113.4c0 11-8.9 20-20 20z"
        data-original="#efc8a0"
      ></path>
      <path
        fill="#c47e4d"
        d="M740.1 274.4v667.1c0 6.2-5 11.3-11.3 11.3H186.9c-6.2 0-11.3-5.1-11.3-11.3V274.4c0-6.2 5-11.3 11.3-11.3h541.8c6.3 0 11.4 5 11.4 11.3z"
        data-original="#c47e4d"
      ></path>
      <path
        fill="#e1efff"
        d="M673.2 897.1H242.5c-6.2 0-11.3-5.1-11.3-11.3V330c0-6.2 5-11.3 11.3-11.3h430.6c6.2 0 11.3 5 11.3 11.3v555.8c.1 6.3-5 11.3-11.2 11.3z"
        data-original="#e1efff"
      ></path>
      <path
        fill="#b0ccdd"
        d="M585.3 473.8H414.6c-7.5 0-13.5-6.1-13.5-13.5 0-7.5 6.1-13.5 13.5-13.5h170.7c7.5 0 13.5 6.1 13.5 13.5s-6.1 13.5-13.5 13.5zM322.9 484c-3.6 0-7-1.4-9.6-4l-17.6-17.6c-5.3-5.3-5.3-13.9 0-19.2s13.9-5.3 19.2 0l8 8 31.2-31.2c5.3-5.3 13.9-5.3 19.2 0s5.3 13.9 0 19.2L332.4 480c-2.5 2.5-5.9 4-9.5 4zm262.4 99.2H414.6c-7.5 0-13.5-6.1-13.5-13.5 0-7.5 6.1-13.5 13.5-13.5h170.7c7.5 0 13.5 6.1 13.5 13.5s-6.1 13.5-13.5 13.5zm-262.4 10.1c-3.5 0-6.9-1.3-9.6-4l-17.6-17.6c-5.3-5.3-5.3-13.9 0-19.2s13.9-5.3 19.2 0l8 8 31.2-31.2c5.3-5.3 13.9-5.3 19.2 0s5.3 13.9 0 19.2l-40.8 40.8c-2.7 2.7-6.2 4-9.6 4zm262.4 99.2H414.6c-7.5 0-13.5-6.1-13.5-13.5 0-7.5 6.1-13.5 13.5-13.5h170.7c7.5 0 13.5 6.1 13.5 13.5s-6.1 13.5-13.5 13.5zm-262.4 10.2c-3.6 0-7-1.4-9.6-4l-17.6-17.6c-5.3-5.3-5.3-13.9 0-19.2s13.9-5.3 19.2 0l8 8 31.2-31.2c5.3-5.3 13.9-5.3 19.2 0s5.3 13.9 0 19.2l-40.8 40.8c-2.6 2.6-6 4-9.6 4zm262.4 99.2H414.6c-7.5 0-13.5-6.1-13.5-13.5 0-7.5 6.1-13.5 13.5-13.5h170.7c7.5 0 13.5 6.1 13.5 13.5s-6.1 13.5-13.5 13.5zm-262.4 10.2c-3.6 0-7-1.4-9.6-4l-17.6-17.6c-5.3-5.3-5.3-13.9 0-19.2s13.9-5.3 19.2 0l8 8 31.2-31.2c5.3-5.3 13.9-5.3 19.2 0s5.3 13.9 0 19.2l-40.8 40.8c-2.6 2.5-6 4-9.6 4z"
        data-original="#b0ccdd"
      ></path>
      <path
        fill="#365e7d"
        d="M532.3 247.5H383.4v-62.8c0-11 9-20 20-20h108.9c11 0 20 9 20 20z"
        data-original="#365e7d"
      ></path>
      <path
        fill="#477b9e"
        d="M587.3 343.8h-259c-5.7 0-10.3-4.6-10.3-10.3v-90.7c0-13.6 11.1-24.7 24.7-24.7h230.2c13.7 0 24.7 11.1 24.7 24.7v90.7c.1 5.6-4.6 10.3-10.3 10.3z"
        data-original="#477b9e"
      ></path>
    </svg>
  );
}

export default BulkOrder;